import React, { Component } from "react";

import { 
  //USERURL, 
  //USERCONFIGURL, 
  ISDEV } from "./helpers/constants";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators as userActionCreators } from "./actions/userActions";
import { actionCreators as uiActionCreators } from "./actions/uiActions";

import Dashboard from "./app/dashboard/DashboardContainer";

import { isMobile } from "react-device-detect";
import { withTranslation } from 'react-i18next';
import ErrorBoundary from './app/generic/ErrorBoundary'

import {
  PRESENTATION_MODE,
  //PRESENTATION_MODE_DEFAULT,
  //PRESENTATION_MODE_FIT_H,
  //PRESENTATION_MODE_FIT_V,
  //PRESENTATION_MODE_STACK_H,
  //PRESENTATION_MODE_STACK_V
} from "./helpers/constants";

class App extends Component {
  componentDidMount() {
    console.log("App mounted.");
    if (!this.props.loggedIn) {
      console.log("Not logged in...");
    }

    var fetchUserCallback = function() {
      if (isMobile) {
        console.log("Is mobile.");
        this.props.setUIMode(false, false);
        this.props.setPresentationViewMode(
          PRESENTATION_MODE.PRESENTATION_MODE_STACK_V
        );
      }
    };

    this.props.fetchUser(fetchUserCallback.bind(this));
    console.log("APP - Fetch user");
  }

  render() {
    let { loggedIn } = this.props;

    console.log("USER:", this.props.user);
    if (this.props.user.phase === "PENDING") {
      console.log("-PENDING");
      return (
        <div>
          <br />
        </div>
      );
    } else if (!!!this.props.user.username) {
      console.log("-REDIRECT");
      return <Redirector />;
    } else {
      console.log("-DASHBOARD");
      console.log("Finished:", loggedIn);
      return (
        <div className="dashboard-wrapper">
          <ErrorBoundary>
            <Dashboard />
          </ErrorBoundary>
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    loggedIn: !!state.user.username
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...userActionCreators, ...uiActionCreators },
    dispatch
  );
}

const ConnectedApp = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default withTranslation()(ConnectedApp);

class Redirector extends Component {
  componentDidMount() {
    if (!ISDEV) {
      window.location = "/login";
    }
  }

  render() {
    return null;
  }
}
